

const TaskCell = ({ task, splitTask, getTaskChilds }) => {
  const childs = getTaskChilds(task);

  const hasResources = +task.resources > 0;

  const taskDuration = splitTask
    ? hasResources
      ? +splitTask.duration * +task.resources
      : +splitTask.duration
    : hasResources
      ? +task.duration * +task.resources
      : +task.duration;

  const taskSubtasksHours = task.record === 'T' && childs.length > 0
    ? childs.reduce((acc, child) => child.record === 'ST' ? acc + +child.duration : acc, 0)
    : undefined;

  return (
    <>
      { task.name + ` [${taskDuration}]` }
      { taskSubtasksHours > 0 && ` (${taskSubtasksHours})` }
    </>
  );
};

export default TaskCell;